import { Box, Button, CircularProgress, Modal, Pagination, Stack, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import Swal from 'sweetalert2'
import { useUpdateMappedChannelProductMutation } from '../../../hooks/RTK_Service/MapUnmapProductData'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 480,
  bgcolor: 'background.paper',
  borderRadius: '7px',
  boxShadow: 24,
  p: 4,
}

export default function MapTable({ MapProductData, pageNumber, handlePageNumber, refreshData }) {
  const [openModal, setOpenModal] = useState(false)
  const [editData, setEditData] = useState(null)
  const [updateMappedChannelProduct, { isLoading: updating }] = useUpdateMappedChannelProductMutation()

  const handleOpenUpdate = (data) => {
    setEditData({ id: data.id, sku: data.sku, channelPrice: data.channelPrice ?? '', channelSalePrice: data.channelSalePrice ?? '' })
    setOpenModal(true)
  }

  const handleClose = () => {
    setEditData(null)
    setOpenModal(false)
  }

  const handleUpdate = async () => {
    try {
      const res = await updateMappedChannelProduct(editData).unwrap()
      Swal.fire('Success', res?.message || 'Updated successfully.', 'success')
      handleClose()
      if (refreshData) refreshData()
    } catch (err) {
      Swal.fire('Error', err?.data?.message || 'Failed to update.', 'error')
    }
  }

  return (
    <div>
      <div className="table-responsive">
        <table className="table table-hover mt-2">
          <thead style={{ borderBottom: "1px solid black" }}>
            <tr>
              <th scope="col">CHANNEL ID</th>
              <th scope="col">CHANNEL SKU</th>
              <th scope="col">CHANNEL PRODUCT ID</th>
              <th scope="col">CHANNEL PRODUCT TITLE</th>
              <th scope='col'>SKU</th>
              <th scope="col">CHANNEL PRICE</th>
              <th scope="col">CHANNEL SALE PRICE</th>
              <th scope="col">ACTION</th>
            </tr>
          </thead>
          <tbody>
            {MapProductData?.content?.map((data) => (
              <tr key={"map" + data.id}>
                <td>{data?.channelId}</td>
                <td>{data.channelSku}</td>
                <td>{data.channelProductId}</td>
                <td>{data.channelProductTitle}</td>
                <td>{data.sku}</td>
                <td>{data.channelPrice}</td>
                <td>{data.channelSalePrice}</td>
                <td>
                  <button onClick={() => handleOpenUpdate(data)} className='btn btn-sm btn-outline-warning'>Update</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="right">
          <Stack spacing={2}>
            <Pagination color="primary" count={MapProductData?.totalPages} page={pageNumber} onChange={(e, v) => handlePageNumber(v)} />
          </Stack>
        </div>
      </div>

      <Modal open={openModal} onClose={handleClose} aria-labelledby="update-modal-title">
        <Box sx={style}>
          <Typography id="update-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
            Update Mapped Product
          </Typography>
          {editData && (
            <>
              <TextField
                fullWidth
                label="SKU"
                size="small"
                value={editData.sku}
                onChange={(e) => setEditData({ ...editData, sku: e.target.value })}
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label="Channel Price"
                size="small"
                type="number"
                value={editData.channelPrice}
                onChange={(e) => setEditData({ ...editData, channelPrice: e.target.value })}
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label="Channel Sale Price"
                size="small"
                type="number"
                value={editData.channelSalePrice}
                onChange={(e) => setEditData({ ...editData, channelSalePrice: e.target.value })}
                sx={{ mb: 3 }}
              />
              <Button
                fullWidth
                variant="contained"
                color="warning"
                onClick={handleUpdate}
                disabled={updating}
                sx={{ py: 1.5 }}
              >
                {updating ? <CircularProgress size={20} color="inherit" /> : 'Update'}
              </Button>
            </>
          )}
        </Box>
      </Modal>
    </div>
  )
}
